import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import IconBtn from '../modules/icon-btn/icon-btn';
import LoadDocBtn from '../modules/load-doc-btn';
import { RootState, SignResultStateType } from '../types';
import { downloadFile, getPdfFromBase64 } from '../utils/files/downloadFile';
import fileDownload from 'js-file-download';
import { getSignDocName } from '../utils/strings/getSignDocName';

export type UseSignResultHookOptionsType = {
  submitPath: string;
  closePath: string;
  btnTitle?: string;
};

const DEFAULT_BTN_TITLE = 'Закрыть и перейти';
const DEFAULT_CLOSE_PATH = '/orders';

type MapNameType = keyof SignResultStateType;

export const useSignResultHook = (
  mapName: MapNameType,
  options: Partial<UseSignResultHookOptionsType>
) => {
  const history = useHistory();
  const resultState = useSelector(
    (state: RootState) => state.signResult[mapName]
  );
  const decisionId = useSelector(
    (state: RootState) => state.operationsSign.data[mapName].decisionId
  );
  const signatureDoc = useSelector(
    (state: RootState) => state.operationsSign.data[mapName].signedDoc
  );
  const decisionDoc = useSelector(
    (state: RootState) => state.operationsSign.data[mapName].decisionDoc
  );

  const getDocsBtns = () => {
    const docsArr = [];
    if (decisionDoc && decisionId) {
      docsArr.push(
        <LoadDocBtn
          sig={!!signatureDoc}
          title={getSignDocName(decisionId)}
          onSpecDownload={() => {
            // const resultBlob = getPdfFromBase64(decisionDoc, );
            fileDownload(decisionDoc, getSignDocName(decisionId),
            'application/pdf')
            // downloadFile(
            //   resultBlob,
            //   getSignDocName(decisionId),
            //   'application/pdf'
            // );
          }}
          onSpecDownloadSig={() => {
            if (signatureDoc) {
              const resultBlob = getPdfFromBase64(signatureDoc);
              downloadFile(
                resultBlob,
                getSignDocName(decisionId) + '.sig',
                'application/pdf'
              );
            }
          }}
        />
      );
    }

    return docsArr;
  };

  const onClose = () => {
    history.push(options.closePath ?? DEFAULT_CLOSE_PATH);
  };

  const SubmitBtn = (
    <IconBtn
      title={options.btnTitle ?? DEFAULT_BTN_TITLE}
      onClick={() => {
        history.push(options.submitPath ?? '/assets');
      }}
    />
  );

  return {
    getDocsBtns,
    submitBtn: SubmitBtn,
    success: !!resultState.success,
    onClose,
  };
};
